import { RoleApiResponse } from "../types/settings/RoleTypes";
import { ApiResponse } from "../utils/api/ApiProps";
import api from "../utils/api";

export const getRoles = async (): Promise<ApiResponse<RoleApiResponse>> => {
  const response = await api.req<RoleApiResponse>({
    url: "/roles",
    method: api.Method.GET,
  });
  return response;
};

export interface GetTableParams {
  page?: number;
  search_term?: string;
  sort_column?: string;
  sort_order?: "ASC" | "DESC";
  col_order?: number;
  include_options?: boolean;
  limit?: number;
}

export const getLeadNotifications = async (params: any) => {
  const response = await api.req({
    url: "/notifications_demo",
    method: api.Method.POST,
    body: params,
  })
  return response;
}
export const postKnowlarityNumber = async (params: any) => {
  const response = await api.req({
    url: "/clients/knowlarity-integartion",
    method: api.Method.POST,
    body: params,
  })
  return response;
}

export interface Integration {
  uuid: string;
  integration_id: number;
  type?: number; // Mapped from integration_type (for backward compatibility)
  integration_type?: number; // Direct database field
  type_label?: string;
  code?: string; // Mapped from integration_code (for backward compatibility)
  integration_code?: string; // Direct database field
  created_at: string;
  updated_at: string;
}

export interface IntegrationsResponse {
  integrations: Integration[];
  count: number;
}

export const getClientIntegrations = async (): Promise<ApiResponse<IntegrationsResponse>> => {
  const response = await api.req<IntegrationsResponse>({
    url: "/clients/integrations",
    method: api.Method.GET,
  });
  return response;
};

export interface DeleteIntegrationResponse {
  integration_uuid: string;
  integration_type: number;
  integration_code: string;
}

export const deleteClientIntegration = async (integrationUuid: string): Promise<ApiResponse<DeleteIntegrationResponse>> => {
  const response = await api.req<DeleteIntegrationResponse>({
    url: `/clients/integrations/${integrationUuid}`,
    method: api.Method.DELETE,
  });
  return response;
};

export interface FacebookPixelResponse {
  integration_uuid: string;
  client_id: number;
  pixel_code: string;
  integration_type: number;
  integration_id: number;
}

export const postFacebookPixelIntegration = async (params: { pixel_code: string }): Promise<ApiResponse<FacebookPixelResponse>> => {
  const response = await api.req<FacebookPixelResponse>({
    url: "/clients/facebook-pixel-integration",
    method: api.Method.POST,
    body: params,
  });
  return response;
};